// =============================================================================
// Header Pop
// =============================================================================

$('document').ready(() => {
    const $window = $(window);
    const $siteHeader = $('.site-header');
    const headerHeight = $siteHeader.height();

    let previousTop = 0;

    const handleScroll = () => {
        const currentTop = $window.scrollTop();

        if (currentTop < previousTop) {
            // If going up...
            $siteHeader.removeClass('site-header--hide');
        } else {
            // If going down...
            if (currentTop > (headerHeight * 4)) {
                $siteHeader.addClass('site-header--hide');
            }
        }

        previousTop = currentTop;
    };

    $window.on('scroll', { previousTop: 0 }, handleScroll.bind(this));
});



// WEBPACK FOOTER //
// ./public/themes/masuri/assets/js/library/HeaderPop.js